// extracted by mini-css-extract-plugin
export var cardIcon = "_7w-4";
export var checkboxCard = "_7w-0";
export var checkboxCardSelected = "_7w-3";
export var disabled = "_7w-1";
export var outerBorder = "_7w-2";
export var spacerMedium = "_7w-7";
export var spacerSmall = "_7w-6";
export var spacerXsmall = "_7w-5";